module.exports = __webpack_public_path__ + "img/banner_lens.33ae9f63.png";